<template>
  <div class="max-w-lg mx-auto p-4">
    <locale-form-provider :webform-id="webformId" :defaultLang="$route.params.lang" @validations="updateValidations" #default="{ currentLocale, rtl, locales, form, setLocale }">
      <div class="mt-4 mb-2 flex justify-between items-center">
        <img v-if="form.logo" class="w-56" alt="Logo" :src="form.logo">
        <locale-switcher v-if="locales.length > 1" :value="currentLocale" :locales="locales" @input="setLocale"/>
      </div>

      <main class="pt-4 mb-6" :class="{ rtl }">
        <async-form :form="form" :submit="onFormSubmit" novalidate autocomplete="off"
                    #default="{ hasError, errorMessage }">
          <div v-if="hasError"
               class="bg-red-100 text-red-800 text-sm border border-red-200 my-6 p-4">
            <p>{{ errorMessage }}</p>
          </div>

          <form-header :form="form" class="mb-6"></form-header>

          <formival-form :fields="form.fields | conditionalFields(model)" :value="model" @input="setModel"
                         :validation="$v.model"></formival-form>

        </async-form>
      </main>
    </locale-form-provider>
    <notification-message v-if="errorMessage" :message="errorMessage" @close="dismissErrorMessage"></notification-message>
  </div>
</template>

<script>
import pick from "lodash.pick";
import LocaleFormProvider from "../components/LocaleFormProvider.vue";
import LocaleSwitcher from "../components/LocaleSwitcher.vue";
import AsyncForm from "../components/AsyncForm.vue";
import FormHeader from "../components/FormHeader.vue";
import conditionalFields from "../filters/conditional-fields-filter";
import mapValidationRules from "../utils/map-validation-rules";
import NotificationMessage from "../components/NotificationMessage.vue";

export default {
  name: "App",
  components: {
    NotificationMessage,
    FormHeader,
    AsyncForm,
    LocaleSwitcher,
    LocaleFormProvider
  },
  filters: {
    conditionalFields
  },
  data() {
    return {
      defaultLogo: "/logo.png",
      model: {},
      validationRules: {}
    };
  },
  created() {
    this.$store.commit("clearFiles");
  },
  computed: {
    webformId() {
      return this.$route.params.id;
    },
    defaultLangFromPath() {
      return this.$route.params.lang || "en";
    },
    errorMessage() {
      return this.$store.state.errorMessage;
    }
  },
  methods: {
    dismissErrorMessage() {
      this.$store.commit("dismissErrorMessage");
    },
    setModel(newModel) {
      this.model = newModel;
      this.$store.commit("setFormModel", newModel);
    },
    updateValidations(v) {
      this.validationRules = v;
    },
    async onFormSubmit(form) {
      const validKeys = form.fields.filter(({ type }) => type !== "hidden").map(({ key }) => key);
      this.validationRules = mapValidationRules(pick(form.validations, ...validKeys));
      this.$v.$touch();
      if (this.$v.$invalid) {
        // console.log("invalid model", this.model);
        return;
      }
      const formModel = {
        ...this.$store.state.previousModel,
        ...pick(this.model, ...validKeys),
      };
      const response = await this.$store.dispatch("submitWebform", { webformId: this.webformId, ...formModel });
      if (response) {
        await this.$router.push({ name: "confirm", params: { id: this.webformId, response, form } });
      }
    }
  },
  validations() {
    return {
      model: this.validationRules
    };
  }
};
</script>
